import { useTheme } from '@emotion/react'
import { Box } from '@mui/system'
import { ColDef } from 'ag-grid-community'
import { useState, useEffect, useCallback } from 'react'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import { ProrithmDevices, paginationOptions } from '../../ProRithm/Constants'
import { CreateCompany, GetAllCompanies } from '../../../services/AdminService'
import MedAgDataGrid from '../../../components/MedAgDataGrid'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControlLabel,
  Checkbox,
  DialogActions,
} from '@mui/material'
import { Create } from '../../bedManagement/endpoints/EndPoints'
import EditNoteIcon from '@mui/icons-material/EditNote'
import { UserManagementMessages } from '../constants'

export const styles = () => ({
  proRithmDasboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '2%',
    gap: 20,
  },
  proRithmDasboardTableContainer: {
    width: '100%',
    height: '100%',
  },
  proRithmDasboardheading: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  proRithmDasboardCreateBtn: {
    textTransform: 'capitalize',
    backgroundColor: '#4682b4',
  },
  deviceText: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  centerHeader: {
    color: '#ffffff',
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  lightBlue: {
    background: '#4682b4',
  },
})

const Company = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [company, setCompany] = useState<ProrithmDevices[]>([])
  const [openCreate, setOpenCreate] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedCompany, setSelectedCompany] = useState<any>(null)
  const [formData, setFormData] = useState({
    name: '',
    odoo_id: '',
    journal_id: '',
    share_data: false,
    sms: false,
    whatsapp: false,
  })
  const columnDefs: ColDef[] = [
    {
      headerName: 'Thop id',
      field: 'id',
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Name',
      field: 'name',
      width: 300,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Odoo id',
      field: 'odoo_id',
      width: 150,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Journal Id',
      field: 'journal_id',
      width: 150,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Share Data',
      field: 'share_data',
      width: 150,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'SMS',
      field: 'sms',
      width: 150,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'whatsapp',
      field: 'whatsapp',
      width: 150,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Edit',
      field: 'edit',
      width: 150,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellStyle: { textAlign: 'center' },
      cellRenderer: (params: any) => (
        <EditNoteIcon
          fontSize='small'
          className={classes?.calendarMonthIcon}
          onClick={() => handleEditClick(params?.data)}
        />
      ),
    },
  ]
  const fetchCompanies = useCallback(async () => {
    try {
      const response = await GetAllCompanies()
      setCompany(response?.data || [])
    } catch (error) {
      console?.error(error)
    }
  }, [])
  useEffect(() => {
    fetchCompanies()
  }, [fetchCompanies])

  const handleOpenCreate = useCallback(() => {
    setOpenCreate(true)
  }, [])

  const handleCloseCreate = useCallback(() => {
    setOpenCreate(false)
    setFormData({
      name: '',
      odoo_id: '',
      journal_id: '',
      share_data: false,
      sms: false,
      whatsapp: false,
    })
  }, [])

  const handleChange = useCallback((e: any) => {
    const { name, value, checked, type } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }, [])

  const handleSubmit = useCallback(async () => {
    const payload = {
      data: {
        company: {
          ...(isEdit && { id: selectedCompany?.id }),
          name: formData?.name,
          odoo_id: Number(formData?.odoo_id),
          journal_id: Number(formData?.journal_id),
          share_data: formData?.share_data,
          sms: formData?.sms,
          whatsapp: formData?.whatsapp,
        },
      },
    }

    const response = await CreateCompany(payload)
    if (response?.success) {
      handleCloseCreate()
      fetchCompanies()
    } else {
      console.error(UserManagementMessages?.CompanyCreation)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, fetchCompanies, handleCloseCreate])
  const handleEditClick = useCallback((rowData: any) => {
    setIsEdit(true)
    setSelectedCompany(rowData)

    setFormData({
      name: rowData.name || '',
      odoo_id: rowData.odoo_id || '',
      journal_id: rowData.journal_id || '',
      share_data: rowData.share_data || false,
      sms: rowData.sms || false,
      whatsapp: rowData.whatsapp || false,
    })
    setOpenCreate(true)
  }, [])

  const FilterActions = () => {
    return (
      <>
        <Button
          variant='contained'
          size='small'
          className={classes?.proRithmDasboardCreateBtn}
          onClick={handleOpenCreate}
        >
          {Create}
        </Button>
      </>
    )
  }

  return (
    <Box height='93%' width='100%'>
      <Box className={classes?.proRithmDasboardContainer} height='100%'>
        <Box className={classes?.proRithmDasboardTableContainer}>
          <MedAgDataGrid
            tableHeading='Company'
            tableHeight={'100%'}
            rowData={company}
            columnDefs={columnDefs}
            pagination={false}
            pageSizeOptions={paginationOptions}
            headerHeight={30}
            searchFieldWidth={300}
            filterActions={<FilterActions />}
          />
        </Box>
      </Box>
      <Dialog
        open={openCreate}
        onClose={handleCloseCreate}
        maxWidth='xs'
        fullWidth
      >
        <DialogTitle>
          {isEdit
            ? UserManagementMessages?.EditCompany
            : UserManagementMessages?.CreatedCompany}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            size='small'
            margin='dense'
            label='Company Name'
            name='name'
            value={formData?.name}
            onChange={handleChange}
            required
          />

          <TextField
            fullWidth
            margin='dense'
            size='small'
            label='Odoo ID'
            name='odoo_id'
            type='number'
            value={formData?.odoo_id}
            onChange={handleChange}
          />

          <TextField
            fullWidth
            margin='dense'
            size='small'
            label='Journal ID'
            name='journal_id'
            type='number'
            value={formData?.journal_id}
            onChange={handleChange}
          />

          <FormControlLabel
            control={
              <Checkbox
                name='share_data'
                checked={formData?.share_data}
                onChange={handleChange}
              />
            }
            label='Share Data'
          />

          <FormControlLabel
            control={
              <Checkbox
                name='sms'
                checked={formData?.sms}
                onChange={handleChange}
              />
            }
            label='SMS'
          />

          <FormControlLabel
            control={
              <Checkbox
                name='whatsapp'
                checked={formData?.whatsapp}
                onChange={handleChange}
              />
            }
            label='WhatsApp'
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseCreate}>Cancel</Button>
          <Button variant='contained' onClick={handleSubmit}>
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default Company
